module.exports = __webpack_public_path__ + "img/Arrow.96420a92.svg";